import * as React from 'react';
const BackgroundBlueMobile = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="360"
    height="458"
    viewBox="0 0 360 458"
    fill="none"
    {...props}
  >
    <g opacity="0.7" filter="url(#filter0_f_3377_82195)">
      <circle cx="243" cy="133" r="225" fill="#E8F2FF" />
    </g>
    <defs>
      <filter
        id="filter0_f_3377_82195"
        x="-82"
        y="-192"
        width="650"
        height="650"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_3377_82195" />
      </filter>
    </defs>
  </svg>
);
export default BackgroundBlueMobile;
